<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <template v-if="$permission.canWrite()">
          <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
          <!-- <el-button class="filter-item" type="danger" @click="delRows">删除</el-button> -->
        </template>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="60px">
          <template slot-scope="{row}">
            <template v-if="row.NeedEnd=='是'">
              <el-button type="text" v-if="row.EndStatus=='待销假'" @click="onEnd(row)">销假</el-button>
            </template>
          </template>
        </el-table-column>
      </template>
    </list>
    <add-dialog ref="addDialog" @close-saved="reload" />
    <end-dialog ref="endDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/wf/leave/list";
import addDialog from "@/components/wf/leave/addDialog";
import endDialog from "@/components/wf/leave/endDialog";

export default {
  name: "leave",
  mixins: [curdMixins],
  components: {
    list,
    addDialog,
    endDialog,
  },
  data() {
    return {
      api: require("@/api/wf/wfleave").default,
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    // /wf/leave?instanceid=41
    var query = this.$route.query;
    if (query.onEnd) {
      this.$router.replace({ query: {} });
      this.$refs.list.query({ EndStatus: "待销假" });
    }
    if (query.instanceid) {
      if (this.$permission.canWrite()) {
        this.api.getMyList({ id: query.instanceid }).then((res) => {
          // console.log("res", res);
          if (res.Data.length > 0) this.onEnd(res.Data[0]);
          this.$router.replace({ query: {} });
        });
      } else {
        this.$message.warning("你没有写入的权限");
      }
    }
  },
  methods: {
    create() {
      this.$refs.addDialog.openCreate();
    },
    onEnd(row) {
      this.$refs.endDialog.openCreate({
        InstanceId: row.InstanceId,
        StartTime: row.StartTime,
        StartTimePart: row.StartTimePart,
        ActualEndTime: row.EndTime,
        EndTime: row.EndTime,
        ActualEndTimePart: row.EndTimePart,
        EndTimePart: row.EndTimePart,
      });
    },
  },
};
</script>